<template>
  <authorization permissionKey="configuration_prosthesis" can="read">
    <v-container fluid>
      <v-row>
        <v-col class="text-h3 gray--text">
          Próteses
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-tabs background-color="transparent" color="secondary">
            <v-tab to="/configuracoes/proteses/modelos">Modelos</v-tab>
            <v-tab to="/configuracoes/proteses/fabricantes">Fabricantes</v-tab>
            <v-tab to="/configuracoes/proteses/proteses">Próteses</v-tab>
          </v-tabs>
        </v-col>
      </v-row>

      <router-view />
    </v-container>
  </authorization>
</template>

<script>
  export default {
    name: "ProsthesisConfig",
  };
</script>

<style lang="scss" scoped></style>
